import t from "../../theme";

export const useGetRewardsScreenStyles = () => {
  return {
    pageContainer: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      backgroundColor: "transparent",
    },
    titleBanner: {
      height: 50,
      background: "#2e7d32",
      marginBottom: 12,
      display: "flex",
      alignItems: "center",
      padding: "0 40px",
      justifyContent: "space-between",
      color: t.brand.white,
      position: "relative",
      boxShadow: "0 4px 20px rgba(46, 125, 50, 0.25)",
      "& h1": {
        color: "inherit",
        fontSize: "18px",
        fontWeight: 600,
        margin: 0,
        textShadow: "0 2px 4px rgba(0,0,0,0.1)",
      },
      "@media (max-width: 768px)": {
        height: 44,
        padding: "0 16px",
        "& h1": {
          fontSize: "15px",
        },
      },
    },
    detailsWrapper: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      padding: "0 35px",
      marginBottom: 10,
    },
    header: {
      background: t.glass.subtle,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      display: "flex",
      gap: 50,
      padding: "32px 25px",
      alignItems: "center",
      borderRadius: t.radius.md,
      border: `1px solid ${t.glass.light}`,
      boxShadow: t.shadow.lg,
    },
    progressWrapper: {
      flex: 1,
    },
    userTypeTitle: {
      marginBottom: 8,
    },
    subWraper: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "0 2rem",
    },
    radioGroup: {
      margin: "5px 25px",
    },
    progressBarTitle: {
      fontSize: 13,
      color: t.text.muted,
      marginTop: 8,
      fontWeight: 500,
    },
    brandCardsWrapper: {
      display: "flex",
      flexWrap: "wrap",
      margin: "15px auto",
      maxWidth: "98%",
      justifyContent: "center",
      gap: "15px",
      padding: "20px 16px",
      background: t.glass.subtle,
      backdropFilter: t.blur.light,
      WebkitBackdropFilter: t.blur.light,
      borderRadius: t.radius.md,
    },
    balanceDetails: {
      display: "flex",
      flexDirection: "column",
      gap: 3,
    },
    balanceDetailsTextLight: {
      fontSize: 10,
      color: t.text.muted,
      fontWeight: 400,
      display: "flex",
      gap: 5,
      alignItems: "center",
      "& > span": {
        opacity: 0.34,
      },
    },
    balanceDetailsTextStrong: {
      fontSize: 18,
      color: t.text.primary,
      fontWeight: 500,
    },
    tandctag: {
      backgroundColor: t.glass.subtle,
      backdropFilter: "blur(10px)",
      color: t.text.muted,
      padding: "6px 14px",
      fontSize: 12,
      border: `1px solid ${t.glass.light}`,
      borderRadius: 20,
      cursor: "pointer",
      fontWeight: 500,
      transition: t.transition.base,
    },
    redeemBtn: {
      maxWidth: 135,
      background: "rgba(46, 125, 50, 0.9)",
      color: t.brand.white,
      fontSize: 10,
      fontWeight: 600,
      paddingTop: 0,
      paddingBottom: 0,
      height: 30,
      borderRadius: 30,
      boxShadow: "0 4px 12px rgba(46, 125, 50, 0.3)",
      "&:hover": {
        background: "rgba(46, 125, 50, 0.95)",
      },
    },
    body: {
      background: t.glass.faint,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      display: "flex",
      margin: "0 35px",
      maxHeight: 500,
      borderRadius: t.radius.md,
      border: `1px solid ${t.glass.light}`,
      overflow: "hidden",
    },
    leftCategoriesPanel: {
      width: 160,
      backgroundColor: t.glass.faint,
      color: t.text.primary,
      maxHeight: "100%",
      overflow: "auto",
      borderRight: `1px solid ${t.glass.light}`,
    },
    rightDetailsPanel: {
      display: "flex",
      flexDirection: "column",
      padding: "20px 50px",
      width: "100%",
    },
    categoryListItem: {
      display: "flex",
      padding: 16,
      gap: 18,
      borderBottom: `1px solid rgba(46, 125, 50, 0.08)`,
      cursor: "pointer",
      transition: t.transition.fast,
      "&:hover": {
        backgroundColor: t.glass.faint,
      },
    },
    earnMoneyBtn: {
      maxWidth: 155,
      background: "rgba(46, 125, 50, 0.9)",
      color: t.brand.white,
      fontSize: 14,
      fontWeight: 600,
      borderRadius: 30,
    },
    flexColItem: {
      display: "flex",
      flexDirection: "column",
      gap: 5,
    },
    flexRowItem: {
      display: "flex",
      gap: 20,
    },
    cardContainer: {
      display: "flex",
      gap: 20,
      padding: "24px 18px",
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      flex: 1,
      borderRadius: t.radius.md,
      border: t.border.base,
      boxShadow: t.shadow.sm,
      transition: t.transition.smooth,
      "&:hover": {
        boxShadow: t.shadow.md,
        transform: "translateY(-2px)",
      },
    },
    offerDetailsContentWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "70px 0",
      gap: "50px",
      justifyContent: "center",
    },
    cardImg: {
      width: 45,
      height: 45,
    },
    cardTitle: {
      margin: 0,
      color: t.text.primary,
      fontSize: 18,
      fontWeight: 600,
    },
    cardDes: {
      margin: 0,
      color: t.text.muted,
      fontSize: 16,
    },
    accordionWrapper: {
      display: "flex",
      gap: 10,
      flexDirection: "column",
      marginTop: 20,
    },
    brandCardsInSearchWrapper: {
      display: "flex",
      flexWrap: "wrap",
      gap: 20,
      justifyContent: "center",
      marginTop: 50,
      marginBottom: 100,
      "& .selectionWrapper": {
        padding: "0!important",
        "& .imageView": {
          borderRadius: 0,
        },
      },
    },
    categoryWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "10px",
    },
    backArrow: {
      position: "absolute",
      top: 20,
      left: 8,
    },
    searchWrapper: {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },
    searchIcon: {
      position: "absolute",
      left: 12,
      width: 32,
      height: 32,
      color: t.text.placeholder,
    },
    search: {
      height: "40px",
      fontSize: "16px",
      width: "100%",
      paddingLeft: "60px",
      fontWeight: 100,
      borderRadius: t.radius.sm,
      border: `1px solid rgba(46, 125, 50, 0.2)`,
      boxShadow: t.shadow.sm,
      background: t.glass.primary,
      backdropFilter: t.blur.light,
      outline: "none",
      transition: t.transition.fast,
    },
    paginationWraper: {
      display: "flex",
      justifyContent: "center",
    },
    backButton: {
      color: t.brand.white,
      fontSize: "15px",
    },
  };
};
